import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-app-badge',
  templateUrl: './ui-app-badge.component.html',
  styleUrls: ['./ui-app-badge.component.scss']
})
export class UiAppBadgeComponent {
  @Input() label = 'SupplySync';
}
